/* Visitor Options Screen Component */
import React from "react";
import { useNavigate } from "react-router";


import '../css/kiosk.css';


const VisitorOptionsScreen = () => {
  const navigate = useNavigate();
  return (
  <div className="options-screen">
          <button className="back-button" onClick={() => navigate('/')}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back
      </button>
    <h2 className="screen-title">Visitor Options</h2>
    <p className="screen-subtitle">Welcome! Please select whether you are signing in or out today.</p>
    
    <div className="options-container">
      <div 
        className="option-button no-tap-highlight" 
        onClick={() => navigate('visitor-sign-in')}
      >
        <div className="option-icon">📝</div>
        <div className="option-label">Sign In</div>
        <div className="option-description">I'm arriving at this location</div>
      </div>
      
      <div 
        className="option-button no-tap-highlight" 
        onClick={() => navigate('visitor-sign-out')}
      >
        <div className="option-icon">👋</div>
        <div className="option-label">Sign Out</div>
        <div className="option-description">I'm leaving this location</div>
      </div>
    </div>
  </div>
  );
};

export default VisitorOptionsScreen;